import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './InfoPopUp.css';

export default class InfoPopUp extends Component {
  static classNames = ({
    textcenter,
  }) => {
    const names = ['InfoPopUp'];
    if (textcenter) {
      names.push('textcenter');
    }
    return names.join(' ');
  };

  static propTypes = {
    showPopUp: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.node.isRequired,
  };

  static defaultProps = {
    showPopUp: false,
    onClick: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPopUp: props.showPopUp,
    };
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.closePopUp);
  }

  closePopUp = (e) => {
    e.preventDefault();
    e.stopPropagation();
    document.body.removeEventListener('click', this.closePopUp);
    this.setState({ showPopUp: false });
  }

  handlePopUp = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const showPopUp = !this.state.showPopUp;

    if (this.props.onClick) {
      this.props.onClick(event, showPopUp);
    }

    this.setState({ showPopUp }, () => {
      if (showPopUp) {
        document.body.addEventListener('click', this.closePopUp);
      } else {
        document.body.removeEventListener('click', this.closePopUp);
      }
    });
  }

  render() {
    const {
      children,
    } = this.props;

    const {
      showPopUp,
    } = this.state;

    return (
      <div className="InfoPopUp popuptext-wrapper">
        <button className="info-icon" onClick={this.handlePopUp} />
        {showPopUp ?
          <span className="popuptext" id="myPopup">
            {children}
          </span>
          : null
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/InfoPopUp.jsx